import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import CardsItem from "@/components/CardsItem.vue";
import { useGameStateStore } from "@/store/gameState";
import ModelProvider from "@/components/providers/ModelProvider.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Cards',
  setup(__props) {

const state = useGameStateStore();

const cardsClassName = "cards";

const classes = computed(() => [cardsClassName]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModelProvider, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(classes))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).doorsState, (item, index) => {
          return (_openBlock(), _createBlock(CardsItem, {
            key: index,
            active: item,
            "on-click": () => _unref(state).pickDoor(index),
            picked: index === _unref(state).pickedDoor,
            prize: index === _unref(state).prizeDoor
          }, null, 8, ["active", "on-click", "picked", "prize"]))
        }), 128))
      ], 2)
    ]),
    _: 1
  }))
}
}

})